// Pure DEV SCENARIO DATA — no React, no UI, no merge logic (that stays in
// report-debug-panel.js's applyDevSourceInputs). Each preset supplies only
// `domainPercentages`; applyDevSourceInputs derives a matching synthetic
// score for each (see its own comment) before mapIQReportModel runs —
// every derived value (Estimated IQ, bandKey, Consistency, ...) falls out
// of that same real calculation path, never hand-authored here.

// null = no override (Reset): mapIQReportModel runs on the untouched
// real/mock source exactly as production would.
export const EMPTY_DEV_OVERRIDES = {
  domainPercentages: null,
};

export const NAMED_DEV_PRESETS = {
  low: {
    // Lands every section (and the 31.67% overall) inside 0-47 below_average.
    domainPercentages: {
      pattern_recognition: 35,
      verbal_reasoning: 30,
      numerical_reasoning: 32,
      logical_deduction: 28,
    },
  },
  mid: {
    // Lands every section (and the 66.67% overall) inside 61-73 average.
    domainPercentages: {
      pattern_recognition: 69,
      verbal_reasoning: 66,
      numerical_reasoning: 63,
      logical_deduction: 71,
    },
  },
  high: {
    // Lands every section (and the 93.33% overall) inside 87-100 above_average.
    domainPercentages: {
      pattern_recognition: 97,
      verbal_reasoning: 92,
      numerical_reasoning: 89,
      logical_deduction: 95,
    },
  },
};

export const DEV_PRESET_NAMES = Object.keys(NAMED_DEV_PRESETS);
